import {Action, History, Location} from 'history';
import {Sender} from 'xstate';
import * as R from 'ramda';
import React from 'react';
import {isNotUndefined} from '@practicegenius/pg-util/src/TypescriptUtils';
import {NavigationEventSchema, NavigationEvent} from './events';

export const useBrowserNavigationListener = (
  history: History,
  send: Sender<NavigationEventSchema>
) => {
  const seenPaths = React.useRef(
    isNotUndefined(history.location.pathname) ? [history.location.pathname] : []
  );

  React.useEffect(() => {
    let previousPath: string | undefined;

    return history.listen((location: Location, action: Action) => {
      const sendBack = (): void => {
        send({type: NavigationEvent.BACK});
      };
      const sendFwd = (): void => {
        send({type: NavigationEvent.FORWARD});
      };

      const {pathname} = location;
      if (
        action === 'POP' &&
        pathname !== previousPath &&
        seenPaths.current.length > 0
      ) {
        // If there is no pathname, it was a goBack.
        if (pathname === undefined) {
          sendBack();
        }

        // If it's an entirely new key, then we are in an unknown state and should just refresh to normalize.
        // If it was neither of the above, you can compare the index
        // of `key` to the previous key in your keys array.
        else if (!seenPaths.current.includes(pathname)) {
          // The browser updates the address bar before we handle the event, so we should be refreshing to a known route
          window.location.reload();
        } else if (
          seenPaths.current.indexOf(pathname) <
          seenPaths.current.indexOf(previousPath as string)
        ) {
          sendBack();
        } else {
          sendFwd();
        }
      }

      if (isNotUndefined(pathname) && pathname !== previousPath) {
        previousPath = pathname;
        seenPaths.current = R.append(pathname, seenPaths.current);
      }
    });
  }, [history, send]);
};
